import type { FunctionComponent, PropsWithChildren, ReactElement } from 'react'

import EditorialThreeRowsHeader from '../epages.editorial/themeHeaders/ThreeRowsHeader'
import EditorialTwoRowsHeader from '../epages.editorial/themeHeaders/TwoRowsHeader'
import OneRowHeader from './themeHeaders/OneRowHeader'
import OneRowLogoLeftHeader from './themeHeaders/OneRowLogoLeftHeader'
import ThreeRowHeader from './themeHeaders/ThreeRowHeader'
import TwoRowsHeader from './themeHeaders/TwoRowsHeader'
import TwoRowsLogoLeftHeader from './themeHeaders/TwoRowsLogoLeftHeader'
import VisionOneRowHeader from '../epages.vision/themeHeaders/OneRowHeader'
import VisionTwoRowsHeader from '../epages.vision/themeHeaders/TwoRowsHeader'

const headerMap: Record<ThemeHeaderTypes, FunctionComponent<PropsWithChildren<any>>> = {
  oneRow: OneRowHeader,
  oneRowLogoLeft: OneRowLogoLeftHeader,
  twoRows: TwoRowsHeader,
  twoRowsLogoLeft: TwoRowsLogoLeftHeader,
  threeRows: ThreeRowHeader,

  // Legacy, old header type names. Needed until the old header type names are
  // no longer in use (i.e. not in the database of any platform).
  // See also "replacementHeaderTypes" in "utils/themes.ts".
  neutral: ThreeRowHeader,
  vision: OneRowLogoLeftHeader,
  twoRowsNestedMenu: TwoRowsLogoLeftHeader,
  uptown: TwoRowsLogoLeftHeader,
  editorial: TwoRowsLogoLeftHeader,
  essence: TwoRowsLogoLeftHeader,
  structure: TwoRowsLogoLeftHeader,
  limelight: TwoRowsLogoLeftHeader,
}

type Props = {
  shop: Core.FullShop
  themeSettings: Theme.Settings
}

export default function ThemeHeader(props: Readonly<Props>): ReactElement {
  const {
    themeSettings,
    shop: { theme },
  } = props

  const selectedHeader: ThemeHeaderTypes = themeSettings?.themeHeader?.headerType
  let Element
  if (selectedHeader === 'twoRows' && theme.name.startsWith('epages.vision')) {
    Element = VisionTwoRowsHeader
  } else if (selectedHeader === 'oneRow' && theme.name.startsWith('epages.vision')) {
    Element = VisionOneRowHeader
  } else if (selectedHeader === 'twoRows' && theme.name.startsWith('epages.editorial')) {
    Element = EditorialTwoRowsHeader
  } else if (selectedHeader === 'threeRows' && theme.name.startsWith('epages.editorial')) {
    Element = EditorialThreeRowsHeader
  } else {
    Element = headerMap[selectedHeader] ?? OneRowHeader
  }

  return <Element {...props} />
}
